import React from 'react';
import { useTranslation } from 'react-i18next';

import { useUserUpload } from '../useUserUpload/useUserUpload';
import * as S from './UploadAlert.styles';

interface UploadAlertProps {
  onViewDetails: () => void;
}

export const UploadAlert = ({ onViewDetails }: UploadAlertProps) => {
  const { t } = useTranslation(['chat']);

  const { alertOpen, errorFiles, completeFiles, toggleAlertOpen } =
    useUserUpload(state => ({
      alertOpen: state.alertOpen,
      errorFiles: state.files.filter(f => f.status === 'error'),
      completeFiles: state.files.filter(f => f.status === 'complete'),
      toggleAlertOpen: state.toggleAlertOpen,
    }));

  const title = (() => {
    if (errorFiles.length === 1) {
      return t('chat:uploadAlert.singleFileError', {
        errorMessage: errorFiles[0].errorMessage,
      });
    }

    return t('chat:uploadAlert.failedToUploadWithCount', {
      count: errorFiles.length,
    });
  })();

  return (
    alertOpen && (
      <S.StyledUploadAlert
        title={title}
        onClose={() => {
          toggleAlertOpen(false);
        }}
        primaryBtn={
          completeFiles.length
            ? {
                label: t('chat:uploadAlert.viewDetails'),
                onClick: () => {
                  onViewDetails();
                  toggleAlertOpen(false);
                },
              }
            : undefined
        }
        data-testid="upload-alert"
      />
    )
  );
};
